import { http } from 'vue'

export default {
  // create contact at the API server
  postRestriction (context, params = {}) {
    return http.post('restrictions', params.data)
  },
  // edit contact at the API server
  putRestriction (context, params = {}) {
    return http.put('restrictions/' + params.id, params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/restrictions/actions.js